"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _counter = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/counter.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _counter.default);
/** Status Indicators are used to easily highlight the state of an object. */

var Counter = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var localizedText = _ref.localizedText,
      notification = _ref.notification,
      children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      props = (0, _objectWithoutProperties2.default)(_ref, ["localizedText", "notification", "children", "className", "cssNamespace"]);
  var counterClasses = classnames("".concat(cssNamespace, "-counter"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-counter--notification"), notification), className);
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, props, {
    "aria-label": localizedText.counterLabel,
    className: counterClasses,
    ref: ref
  }), children);
});

Counter.displayName = 'Counter';
process.env.NODE_ENV !== "production" ? Counter.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    /** The aria-label for the <span> element */
    counterLabel: _propTypes.default.string
  }),

  /** Set to **true** to enable counter with notification */
  notification: _propTypes.default.bool
} : void 0;
Counter.defaultProps = {
  localizedText: {
    counterLabel: 'Unread count'
  }
};

var _default = (0, _withStyles.default)(Counter);

exports.default = _default;